
import RangeInput from '@/components/form/RangeInput'
import vClickOutside from 'v-click-outside'

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: { RangeInput },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    defaultPriceRange: {
      type: Object,
      default() {
        return {
          min: 0,
          max: 5000,
        }
      },
    },
  },
  data() {
    return {
      is_mobile: false,
      mobile_threshhold: 1200, //comps falls into mobile mode
      input: {
        cate: this.$route.query.cate ? this.$route.query.cate.split(',') : [],
        loc: this.$route.query.loc ? this.$route.query.loc.split(',') : [],
        price_range: {
          min: this.$route.query.fprice ? this.$route.query.fprice : '',
          max: this.$route.query.eprice ? this.$route.query.eprice : '',
        },
        status: this.$route.query.status ? this.$route.query.status.split(',') : [],
      },
      temp_filter: {},
    }
  },
  watch: {
    input: {
      handler(val) {
        if (this.is_mobile != true) {
          this.$emit('update', val)
        }
      },
      deep: true,
    },
    is_mobile(val) {
      if (val != true && this.showModal == true) {
        this.closeModal()
      }
    },
    showModal(val) {
      if (val == true) {
        this.temp_filter = { ...this.filter }
      } else {
        this.temp_filter = {}
      }
      this.$nuxt.$emit('ja-backdrop', val)
    },
  },
  beforeMount() {
    this.$nextTick(() => {
      this.onResize()
    })
    this.is_mobile = window.innerWidth < this.mobile_threshhold ? true : false
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.is_mobile = window.innerWidth < this.mobile_threshhold ? true : false
    },
    resetRange() {
      this.$refs.priceRanger.reset()
    },
    handelSubmitRange(payload) {
      this.input.price_range.min = payload.min
      this.input.price_range.max = payload.max
    },
    closeModal() {
      this.$emit('toggled', false)
    },
    submit() {
      this.$emit('update', this.input)
      this.$emit('toggled', false)
    },
  },
}
